'use client';

import React, { useMemo } from 'react';

import { withEventScope } from '@repo/event-processor';
import { H1 } from '@repo/ui-kit/components/core/Typography';

import {
  ComponentContainer,
  ComponentWrapper,
} from 'strapi/component/shared/styles';

import { ImageTextTile } from '../ImageTextTile';

import { KeyPointsRows, KeyPointsRow } from './styles';
import { KeyPointsColumnProps } from './types';
import { arrangeByRows, getRowSize } from './utils';

const KeyPointsColumn: React.FC<KeyPointsColumnProps> = ({
  title,
  keyPoints,
}) => {
  const rowSize = getRowSize(keyPoints.length);
  const organizedKeyPoints = useMemo(
    () => arrangeByRows(keyPoints, rowSize),
    [keyPoints, rowSize]
  );

  return (
    <ComponentWrapper>
      <ComponentContainer>
        <KeyPointsRows>
          <H1 bold as="h2">
            {title}
          </H1>
          {organizedKeyPoints.map((keyPointsRow, index) => (
            <KeyPointsRow
              key={`keyPointsRow-${index}`}
              itemCount={keyPointsRow.length}
            >
              {keyPointsRow.map((item, index) => (
                <ImageTextTile
                  key={index}
                  description={item.description}
                  image={item.image}
                  size={keyPointsRow.length === 4 ? 'm' : 'l'}
                  title={item.title}
                  url={item.url}
                />
              ))}
            </KeyPointsRow>
          ))}
        </KeyPointsRows>
      </ComponentContainer>
    </ComponentWrapper>
  );
};

export default withEventScope(KeyPointsColumn, { module: 'keyPointsColumn' });
